import { render } from "./VideoLesson.vue?vue&type=template&id=12fe6af2&scoped=true"
import script from "./VideoLesson.vue?vue&type=script&lang=js"
export * from "./VideoLesson.vue?vue&type=script&lang=js"

import "./VideoLesson.vue?vue&type=style&index=0&id=12fe6af2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fe6af2"]])

export default __exports__